import * as React from 'react';

import { Selection } from '../enums';

interface DayCellProps {
  day: number;
  numWorkers?: number;
  disabled?: boolean;

  selection: Selection;
  requestSelected?: (_: Selection) => void;

  changeSelectedOnMove: boolean;
  selectOnMoveStatus: Selection;
}

export class DayCell extends React.Component<DayCellProps, {}> {
  render() {
    const classNames = [];
    const innerSpanClassNames = ['center'];
    if (this.props.selection !== Selection.None) {
      classNames.push('selected');
      innerSpanClassNames.push('selected');
    }
    if (this.props.disabled !== undefined && this.props.disabled) {
      classNames.push('disabled');
    }
    if (!this.props.disabled && this.props.requestSelected !== undefined) {
      classNames.push('selectable');
    }
    return (
      <td
        className={classNames.join(' ')}
        onMouseDown={(e: React.MouseEvent<HTMLElement>) => {
          let nextSelection = Selection.Offsite;
          if (this.props.selectOnMoveStatus !== Selection.Offsite) {
            if (this.props.selection === Selection.None) {
              nextSelection = Selection.Selected;
            } else {
              nextSelection = Selection.None;
            }
          }

          if (this.props.requestSelected) {
            this.props.requestSelected(nextSelection);
          }
        }}
        onMouseMove={() => {
          if (this.props.changeSelectedOnMove && this.props.requestSelected) {
            this.props.requestSelected(this.props.selectOnMoveStatus);
          }
        }}
      >
        <span className={innerSpanClassNames.join(' ')}>
          {this.props.selection !== Selection.Offsite ? (
            this.props.day
          ) : (
            <div className="circle selected center">{this.props.day}</div>
          )}
        </span>
      </td>
    );
  }

  setSelected(selected?: boolean) {
    if (selected === undefined) {
      selected = false;
    }
    this.setState({
      isSelected: selected,
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/DayCell.tsx